module.exports = __webpack_public_path__ + "img/Group 103.087aae96.jpg";